import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RecentlyViewedItem } from "../../models/interfaces";

const MAX_RECENT_ITEMS = 5;

interface RecentlyViewedState {
    items: RecentlyViewedItem[];
    loaded: boolean;
}

const initialState: RecentlyViewedState = {
    items: [],
    loaded: false,
};

const recentlyViewedSlice = createSlice({
    name: "recentlyViewed",
    initialState,
    reducers: {
        addRecentlyViewed: (state, action: PayloadAction<RecentlyViewedItem>) => {
            // Upsert: if same docGuid exists, update viewedAt and move to front
            const existingIndex = state.items.findIndex(
                (item) => item.docGuid === action.payload.docGuid
            );
            if (existingIndex >= 0) {
                state.items.splice(existingIndex, 1);
            }
            // Add to front (most recent first)
            state.items.unshift(action.payload);
            // Cap at max items
            if (state.items.length > MAX_RECENT_ITEMS) {
                state.items = state.items.slice(0, MAX_RECENT_ITEMS);
            }
        },
        setRecentlyViewed: (state, action: PayloadAction<RecentlyViewedItem[]>) => {
            state.items = action.payload;
            state.loaded = true;
        },
        clearRecentlyViewed: (state) => {
            state.items = [];
        },
    },
});

export const {
    addRecentlyViewed,
    setRecentlyViewed,
    clearRecentlyViewed,
} = recentlyViewedSlice.actions;

export default recentlyViewedSlice.reducer;
